import { render, staticRenderFns } from "./Illustra.vue?vue&type=template&id=a87b8a12&"
import script from "./Illustra.vue?vue&type=script&lang=js&"
export * from "./Illustra.vue?vue&type=script&lang=js&"
import style0 from "./Illustra.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports